import React, {
  createContext,
  useEffect,
  useContext,
  useReducer,
  useState,
} from 'react';



import Loading from '../components/shared/Loading';
import { USERNAME, ROLE, PERMISSION } from '../constants/common';

const UserContext = createContext();

function userReducer(state, action) {
  switch (action.type) {
    case 'SET_USER': {
      return { user: action.payload };
    }
    default:
      return {};
  }
}

const UserProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const storedUsername = localStorage.getItem(USERNAME);
  const storedRole = localStorage.getItem(ROLE);
  const storedPermission = localStorage.getItem(PERMISSION);

  const initialUser = storedUsername ? {
    userName: storedUsername,
    role: storedRole,
    permission: storedPermission,
  } : null;

  const [state, dispatch] = useReducer(userReducer, { user: initialUser });

  const value = { state, dispatch };

  useEffect(() => {
    setLoading(false);
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <UserContext.Provider value={value}>{children}</UserContext.Provider>
  );
};

const useUser = () => {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }

  return { user: context.state.user, dispatchUser: context.dispatch };
};

export { UserProvider, useUser };
